import React, { useEffect, useState } from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";

import Header from "@/components/header";
import Sidebar from "./sidebar";
import Loader from "@/components/loader";

import api from "@/services/api";
import store from "@/services/store";

export function Layout() {
  const { user, setUser } = store();
  const location = useLocation();

  const [loading, setLoading] = useState(true);

  const redirect = encodeURIComponent(window.location.href.replace(window.location.origin, ""));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    try {
      const res = await api.get("/user/signin_token");
      if (!res.ok || !res.user) return setLoading(false);
      if (res.token) api.setToken(res.token);
      setUser(res.user);
      console.log("res", res);
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  }

  if (loading)
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  if (!user) return <Navigate to={`/auth?redirect=${redirect}`} replace />;

  if (!user.role_candidate) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Sidebar />
      <main className="lg:ml-56 mt-16 min-h-screen p-6">
        <Outlet />
      </main>
    </div>
  );
}
